import useSWR from "swr";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { fetcher, shortAddr } from "../../lib/api";

const shade = (i, n) => {
  const t = n <= 1 ? 0 : i / (n - 1);
  const from = [0, 200, 5], to = [3, 54, 16];
  const c = from.map((f, k) => Math.round(f + (to[k] - f) * t));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
};

export const HolderPie = () => {
  const { data } = useSWR("/holders", fetcher, { refreshInterval: 60000 });
  const holders = data?.holders || [];
  const chartData = [
    ...holders.map((h) => ({ name: shortAddr(h.address), value: h.percent })),
    ...(data?.others_count > 0
      ? [{ name: `Others (${data.others_count})`, value: 100 - holders.reduce((a, h) => a + h.percent, 0) }]
      : []),
  ];

  return (
    <section id="holders" className="max-w-7xl mx-auto px-6 py-20">
      <p className="font-mono text-xs tracking-[0.2em] text-[#00C805] uppercase mb-3">Distribution</p>
      <h2 className="font-heading font-bold text-lg tracking-tight mb-10">Who holds $BANK</h2>
      <div className="card-surface rounded-2xl p-8" data-testid="holder-pie-card">
        {chartData.length === 0 ? (
          <div className="h-64 flex flex-col items-center justify-center text-center">
            <p className="font-mono text-sm text-neutral-500" data-testid="holders-empty-state">
              {data?.configured === false
                ? "Holder chart goes live once the $BANK contract is deployed and indexed."
                : "Indexing holders…"}
            </p>
          </div>
        ) : (
          <div className="h-96 relative">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={chartData} dataKey="value" nameKey="name" innerRadius="55%" outerRadius="90%" strokeWidth={1} stroke="#050505">
                  {chartData.map((_, i) => <Cell key={i} fill={shade(i, chartData.length)} />)}
                </Pie>
                <Tooltip
                  contentStyle={{ background: "#0C0C0C", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, fontFamily: "JetBrains Mono", fontSize: 12 }}
                  formatter={(v) => [`${Number(v).toFixed(3)}%`, "supply"]}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <p className="font-mono font-semibold text-3xl text-[#00C805]">{data?.total?.toLocaleString()}</p>
              <p className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase mt-1">holders</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
